import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { PRICING, SITE } from '@/content/site';
import { TID } from '@/constants/testIds';

const ease = [0.16, 1, 0.3, 1];

export default function Pricing() {
  return (
    <section id="pricing" className="py-28 lg:py-36">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.9, ease }}
        >
          <div className="text-overline mb-7">Pricing</div>
          <h2 className="font-display text-[1.75rem] sm:text-3xl lg:text-[2.5rem] leading-[1.15] max-w-3xl">
            Lash lift pricing in
            <span className="italic text-[hsl(var(--primary))] font-medium"> Vancouver.</span>
          </h2>
          <p className="mt-7 text-[hsl(var(--muted-foreground))] max-w-2xl leading-relaxed">
            Transparent, all-inclusive pricing. Every lash lift includes a complimentary tint.
            No hidden fees, no upsells — book the package that fits your lashes and your
            lifestyle.
          </p>
        </motion.div>

        <ul className="mt-16 divide-y divide-[hsl(var(--hairline))] border-y border-[hsl(var(--hairline))]">
          {PRICING.map((p, i) => (
            <motion.li
              key={p.name}
              data-testid={TID.pricingRow(i)}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.7, ease, delay: i * 0.05 }}
              className="group flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-3 py-8 lg:py-9 hover:px-4 transition-all duration-500"
            >
              <div className="flex-1">
                <div className="flex flex-wrap items-baseline gap-3">
                  <h3 className="font-display text-[1.35rem] lg:text-[1.6rem] tracking-tight group-hover:text-[hsl(var(--primary))] transition-colors duration-500">
                    {p.name}
                  </h3>
                  {p.popular && (
                    <span className="text-[0.58rem] tracking-[0.32em] uppercase text-[hsl(var(--primary))] border border-[hsl(var(--primary))]/35 rounded-full px-2.5 py-0.5 font-light">
                      Popular
                    </span>
                  )}
                </div>
                <div className="mt-2 text-[0.62rem] uppercase tracking-[0.28em] text-[hsl(var(--muted-foreground))] font-light">
                  {p.duration}
                </div>
              </div>
              <div className="font-display text-3xl lg:text-[2.4rem] tracking-tight tabular text-[hsl(var(--foreground))] min-w-[6rem] sm:text-right">
                {p.price}
              </div>
            </motion.li>
          ))}
        </ul>

        <div className="mt-14 flex flex-wrap items-center gap-5">
          <a
            data-testid={TID.pricingBookBtn}
            href={SITE.booking}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-luxe inline-flex items-center gap-2.5 rounded-full bg-[hsl(var(--warm-ink))] text-[hsl(var(--cream))] px-9 py-4 text-[0.72rem] tracking-[0.24em] uppercase font-light hover:bg-[hsl(var(--primary))] transition-colors duration-700"
          >
            Book your lash lift
            <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.25} />
          </a>
          <a
            href={SITE.phoneHref}
            className="text-[0.78rem] tracking-[0.12em] uppercase font-light text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--primary))] transition-colors"
          >
            …or call {SITE.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
